import styled from 'react-emotion';
import * as material from '@material-ui/core';
import theme from '@ublend-npm/aulaui-next-web/themes/default';
import styleUtils from '@ublend-npm/aulaui-next-web/styles/utils';

export const TextField = styled(material.TextField)`
  textarea {
    ${styleUtils.typography.headline()};
    color: ${theme.color.designSystem.blackOpacity87};
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 38px;
  }

  .material-section-title-editable {
    color: ${theme.color.designSystem.blackOpacity87};
  }
`;

export const ExtraLarge = styled('span')`
  display: inline-block;
  ${styleUtils.typography.headline()};
  font-size: ${theme.font.size.headline};
  font-family: Work Sans;
  font-style: normal;
  font-weight: ${theme.font.weight.semiBold};
  font-size: 24px;
  line-height: 36px;
`;
